"use client";

import { ArrowRight, CalendarCheck, ChefHat, PhoneCall, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Climate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const trustSignals = [{
    icon: CalendarCheck,
    label: "Fachberatung"
  }, {
    icon: ChefHat,
    label: "Individuelle Planung"
  }, {
    icon: Sparkles,
    label: "Vollständige Installation"
  }];
  return <section data-section-id="710" id="bereit-für-perfektes-klima" className="relative min-h-[80vh] w-full overflow-hidden bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/ducted_ac_installation_interior.png)] bg-cover bg-center bg-fixed bg-background text-foreground">
      {}
      <div className="absolute inset-0 hidden md:block" style={{
      background: "linear-gradient(to right, hsla(222, 24%, 10%, 0.85) 0%, hsla(222, 24%, 10%, 0.7) 35%, hsla(222, 24%, 10%, 0.35) 70%, hsla(222, 24%, 10%, 0.2) 100%)"
    }} aria-hidden="true" />
      {}
      <div className="absolute inset-0 md:hidden" style={{
      background: "linear-gradient(to bottom, hsla(222, 24%, 10%, 0.75) 0%, hsla(222, 24%, 10%, 0.85) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-8 right-6 md:top-12 md:right-12 z-20 pointer-events-none">
        <div className="rounded-lg border px-4 py-2 text-[0.7rem] tracking-[0.25em] font-mono uppercase backdrop-blur-sm" style={{
        color: "hsl(186 100% 48%)",
        borderColor: "hsl(186 100% 48% / 0.5)",
        backgroundColor: "hsla(222, 24%, 10%, 0.4)"
      }}>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(186 100% 48%)"
          }} />
            Effizient
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(186 100% 48%)"
          }} />
            Nachhaltig
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(186 100% 48%)"
          }} />
          </span>
        </div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 flex min-h-[80vh] items-center px-6 py-24 md:px-12 lg:px-16 md:py-32 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="w-full md:w-3/5 lg:w-1/2 text-center md:text-left">
          {}
          <div className="mb-6 inline-flex items-center gap-3">
            <span className="h-px w-10" style={{
            backgroundColor: "hsl(186 100% 48%)"
          }} aria-hidden="true" />
            <span className="font-mono text-xs tracking-[0.3em] uppercase" style={{
            color: "hsl(186 100% 48%)"
          }}>
              NABER AIRCONDUCT — Ducted AC System 2025
            </span>
          </div>

          {}
          <h2 className="font-default font-light leading-[1.05] tracking-tight mb-8" style={{
          color: "hsl(0 0% 98%)",
          fontSize: "clamp(2.75rem, 7vw, 6.5rem)"
        }}>
            Das Ducted AC{" "}
            <em className="italic font-normal" style={{
            color: "hsl(186 100% 48%)"
          }}>
              System
            </em>{" "}
            für Ihr Zuhause.
          </h2>

          {}
          <p className="font-default text-lg md:text-xl leading-relaxed mb-10 max-w-xl mx-auto md:mx-0" style={{
          color: "hsl(215 14% 70%)"
        }}>
            Kühlen, hocheffizient heizen und die gesetzlichen Vorgaben (EWärmeG BW) clever erfüllen – komplett im Dachboden versteckt. Erleben Sie flüsterleise Perfektion.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 items-center md:items-start justify-center md:justify-start">
            <Button asChild size="lg" className="rounded-lg h-14 px-8 text-base font-medium shadow-lg group" style={{
            backgroundColor: "hsl(186 100% 48%)",
            color: "hsl(222 24% 5%)"
          }}>
              <Link to="/SolutionPage">
                Lösung entdecken
                <ArrowRight className="ml-1 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="rounded-lg h-14 px-8 text-base font-medium bg-transparent backdrop-blur-sm" style={{
            borderColor: "hsl(0 0% 98% / 0.4)",
            color: "hsl(0 0% 98%)"
          }}>
              <Link to="/ContactPage">
                <PhoneCall className="size-4" />
                Jetzt anfragen
              </Link>
            </Button>
          </div>

          {}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-2 gap-y-4">
            {trustSignals.map((signal, i) => {
            const Icon = signal.icon;
            return <div key={i} data-index={i} className="inline-flex items-center gap-2">
                  <Icon className="size-4" style={{
                color: "hsl(186 100% 48%)"
              }} />
                  <span className="font-mono text-xs tracking-[0.15em] uppercase" style={{
                color: "hsl(0 0% 98%)"
              }}>
                    {signal.label}
                  </span>
                  {i < trustSignals.length - 1 && <span className="mx-3 inline-block size-1 rounded-lg" style={{
                backgroundColor: "hsl(186 100% 48%)"
              }} aria-hidden="true" />}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}